import React from 'react';
import { useTranslation } from 'react-i18next';
import { MapHelpersProps } from 'types/webPlayer';
import { withMe } from '../../MeUserWrapper';
import { MeType } from '../../../models/me';

const MapHelpers = (props: MapHelpersProps & {me: MeType}) => {
  const { t } = useTranslation();
  const { enabled, onClick, me, visible} = props;

  return (visible || me.isStaff) && (
    <div className="player__helpers">
      <button
        title={t('webPlayer.helper.location', 'Toggle position tooltip')}
        type="button"
        style={{
          cursor: 'pointer',
          fontSize: '24px',
          fontWeight: '800',
          height: '32px',
          width: '32px',
        }}
        className={enabled ? 'player__helpers--active' : ''}
        onClick={onClick}
      >
        <svg
          fill="none"
          height="24"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          viewBox="0 0 24 24"
          width="24"
          version="1.1"
          id="svg3"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs
            id="defs3"
          />
          <circle
            cx="12"
            cy="12"
            r="8"
            id="circle1"
          />
          <line
            x1="12"
            y1="10.225464"
            x2="12"
            y2="13.774536"
            id="line2"
            style={{ strokeWidth: 1.18302 }}
          />
          <line
            x1="10.225464"
            y1="12"
            x2="13.774536"
            y2="12"
            id="line3"
            style={{ strokeWidth: 1.18302 }}
          />
          <g
            id="g3"
          >
            <line
              x1="18.206804"
              y1="12.002651"
              x2="21.755875"
              y2="12.002651"
              id="line3-9"
              style={{ strokeWidth: 1.18302 }}
            />
            <line
              x1="2.2281036"
              y1="12.002651"
              x2="5.7771759"
              y2="12.002651"
              id="line3-9-6"
              style={{ strokeWidth: 1.18302 }}
            />
          </g>
          <g
            id="g3-6"
            transform="rotate(-89.932938,11.986694,12.005299)"
          >
            <line
              x1="18.206804"
              y1="12.002651"
              x2="21.755875"
              y2="12.002651"
              id="line3-9-2"
              style={{ strokeWidth: 1.18302 }}
            />
            <line
              x1="2.2281036"
              y1="12.002651"
              x2="5.7771759"
              y2="12.002651"
              id="line3-9-6-6"
              style={{ strokeWidth: 1.18302 }}
            />
          </g>
        </svg>
      </button>
    </div>
  );
};

export default withMe(MapHelpers);
